import { ClientHomeRouteService } from './../utils/client-home-route.service';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from 'src/app/store/state/app.state';
import { TokenService } from '../token/token.service';
import { UserRoleType } from "src/app/models/userRoleTypes";
import { AuthService } from "../http/auth.service";

@Injectable()
export class AdministratorGuard  {

    isAdministrator = false;

    constructor(public tokenService: TokenService, private store: Store<IAppState>, private router: Router, private clientHomeRouteService: ClientHomeRouteService,
                private authService: AuthService) { }

    canActivate(): Observable<boolean> | boolean {
        return this.checkAdvisor()
            .pipe(switchMap((result) => {
                if (result) {
                    return of(true);
                } else {
                    return of(false);
                }
            }));
    }

    checkAdvisor(): any {
        if (this.tokenService.isAdministrator() || this.authService.doesUserHaveRole(UserRoleType.Advisor)) {
            return of(true);
        } else {
            this.clientHomeRouteService.redirectToHome();
            return of(false);
        }
    }
}
